import updateDocumentData from "../../utils/updateDocumentData";

import { Import } from "./types/Import";

export default function updateImport(firebase, ref, data, { transaction } = {}) {
	data = Import.partial().parse(updateDocumentData(firebase, data));

	if (transaction) {
		return transaction.set(ref, data, { merge: true });
	}

	return ref.set(data, { merge: true });
}
